import type { TrackPlugin, TrackEvent } from '../../core';
import { collectBrowserSystemInfo } from '../shared/collect-browser-system-info';

/**
 * 浏览器系统环境元数据收集插件
 *
 * 在 Web/H5 环境下采集 navigator 系统信息（userAgent、platform、language、屏幕分辨率）
 * 并将 `_shopCart` 填充为系统环境特征 JSON 字符串。若无法采集，回退为 `'web'`。
 * 宿主若显式传入 `_shopCart`，SDK 不覆盖。
 */
export function browserSystemPlugin(): TrackPlugin {
  return {
    name: 'hss-browser-system-plugin',

    transform(event: TrackEvent): TrackEvent {
      // 宿主已显式传入时不覆盖（??= 语义）
      event.properties._shopCart ??= collectBrowserSystemInfo();
      return event;
    },
  };
}
